import React from "react";
import * as Icons from "lucide-react";
import { process } from "../../mock";
import { SectionHeading } from "../SectionHeading";
import Reveal from "../Reveal";

const ProcessSection = () => {
  return (
    <section className="py-20 md:py-28 bg-[#08080f] relative overflow-hidden">
      <div className="glow-blob w-80 h-80 bg-[#00ff87] top-20 right-0" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <SectionHeading
          eyebrow="The Advantage"
          title="Why"
          highlight="DaddyAnna?"
          subtitle="Join us for a game or two and discover the advantages of playing with India's most trusted online cricket id provider."
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {process.map((p, i) => {
            const Icon = Icons[p.icon] || Icons.Star;
            return (
              <Reveal key={p.title} delay={i * 90}>
                <div className="text-center card-neon rounded-2xl p-7 h-full">
                  <div className="h-16 w-16 mx-auto grid place-items-center rounded-full bg-gradient-to-br from-[#00ff87]/20 to-[#00e5ff]/20 text-[#00ff87] mb-5">
                    <Icon size={28} />
                  </div>
                  <h3 className="font-display font-semibold text-lg text-white mb-2">{p.title}</h3>
                  <p className="text-gray-400 text-sm leading-relaxed">{p.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
